import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import AxiosInstance from "../../utils/axiosInstance";
import toast from "react-hot-toast";
export default function OptInModel({
  open,
  handleClose,
  callId,
  ccnCallId,
  handleAPIcall,
  endPoint,
  project_id,
  type,
  editData,
}) {
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    email: "",
    phone: "",
    disadvantage_status_id: [],
    services_offered: "",
    proposal_id: callId || "",
    ccn_call_id: ccnCallId || "",
    project_id: project_id || "",
  });

  // Fetch options once on mount
  useEffect(() => {
    getDisadvantagedStatus();
  }, []);

  const transformData = (items) =>
    items.map(({ id, name }) => ({
      value: id,
      label: name,
    }));

  const getDisadvantagedStatus = () => {
    AxiosInstance.get(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_DISADVANTAGED_STATUS}`,
    )
      .then((response) => {
        setOptions(transformData(response.data?.data || []));
      })
      .catch((error) => console.log(error?.message));
  };

  /**
   * SINGLE SOURCE OF TRUTH FOR FORM DATA
   * This handles both Edit mode and Add mode.
   */
  useEffect(() => {
    if (!open) return;

    if (editData && editData.id) {
      // EDIT MODE: Fill with record data
      setFormData({
        company_name: editData.company_name || "",
        name: editData.name || "",
        email: editData.email || "",
        phone: editData.phone || "",
        services_offered: editData.services_offered || "",
        disadvantage_status_id:
          editData.disadvantage_status?.map((item) => item.id) || [],
        proposal_id: editData.proposal_id || "",
        ccn_call_id: editData.ccn_call_id || "",
        project_id: editData.project_id || "",
      });
      setSelectedOptions(transformData(editData.disadvantage_status || []));
    } else {
      // ADD MODE: Fill with logged in user info
      const loggedInUserInfo = JSON.parse(
        localStorage.getItem("loggedInUserInfo"),
      );
      if (loggedInUserInfo) {
        setFormData({
          name: loggedInUserInfo.first_name || "",
          phone: loggedInUserInfo.phone_number || "",
          email: loggedInUserInfo.email || "",
          company_name: loggedInUserInfo.company_name || "",
          services_offered: "",
          disadvantage_status_id: [],
          proposal_id: callId || "",
          ccn_call_id: ccnCallId || "",
          project_id: project_id || "",
        });
        setSelectedOptions([]);
      }
    }
  }, [editData, open]); // ONLY depend on these two

  const handleChange = (selected) => {
    const ids = Array.isArray(selected)
      ? selected.map((item) => item.value)
      : [];
    setFormData((prev) => ({ ...prev, disadvantage_status_id: ids }));
    setSelectedOptions(selected);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Name is required.";
    if (!formData.email?.trim()) newErrors.email = "Email is required.";
    if (!formData.phone?.trim()) newErrors.phone = "Phone number is required.";
    if (!formData.services_offered?.trim())
      newErrors.services_offered = "Please enter services";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const url = `${process.env.REACT_APP_API_URL}${endPoint}`;
    const payload = {
      ...formData,
      id: editData?.id, // Important for PHP UPDATE
      disadvantage_status_ids: formData.disadvantage_status_id, // Map to PHP expected key
    };

    AxiosInstance.post(url, payload)
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          toast.success(response?.data?.message);
          handleClose();
          handleAPIcall();
        } else {
          toast.error(response?.data?.message || "Operation failed");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      });
  };

  return (
    <Modal size="l" show={open} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">
          {editData ? "Edit OPT Report" : "Add OPT Report"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="px-3" onSubmit={handleSubmit}>
          <div className="row mb-3">
            <div className="col">
              <label className="fw-bold">Name</label>
              <input
                type="text"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                name="name"
                value={formData.name}
                onChange={handleInputChange}
              />
              {errors.name && (
                <div className="text-danger small">{errors.name}</div>
              )}
            </div>
            <div className="col">
              <label className="fw-bold">Email</label>
              <input
                type="email"
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                name="email"
                value={formData.email}
                onChange={handleInputChange}
              />
              {errors.email && (
                <div className="text-danger small">{errors.email}</div>
              )}
            </div>
          </div>

          <div className="row mb-3">
            <div className="col">
              <label className="fw-bold">Phone Number</label>
              <input
                type="text"
                className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
              {errors.phone && (
                <div className="text-danger small">{errors.phone}</div>
              )}
            </div>
            <div className="col">
              <label className="fw-bold">Disadvantaged Status</label>
              <Select
                options={options}
                isMulti
                value={selectedOptions}
                onChange={handleChange}
                placeholder="Select Status..."
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col">
              <label className="fw-bold">Services Offered</label>
              <textarea
                className={`form-control ${errors.services_offered ? "is-invalid" : ""}`}
                name="services_offered"
                value={formData.services_offered}
                onChange={handleInputChange}
              />
              {errors.services_offered && (
                <div className="text-danger small">
                  {errors.services_offered}
                </div>
              )}
            </div>
          </div>

          <div className="text-end">
            <button type="submit" className="btn btn-primary px-4">
              Save
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
